module.exports = __webpack_public_path__ + "img/777.77240ab6.png";